// register component(s) with react habitat
import codeSplit from 'scripts/higher-order-components/codeSplit'

export default {
  SocialShare: codeSplit({
    loadComponent: () =>
      import(
        /* webpackChunkName: "SocialShare" */
        './index'
      ),
  }),
}
